/**
 * A stable per-browser device id for chat v1.
 *
 * The backend's `POST /devices` must precede `POST /ws-ticket` (tickets only issue to a
 * registered device of the account — CHAT-SERVICE.md §4.0), and each device's delivery
 * cursor (`my_ack_seq`) is keyed on it, so this id must be minted ONCE and never change.
 * Distinct from `av_relay_device` (that is the paired *edge machine* target, not this
 * browser). Mirrors relay.ts's guarded localStorage read.
 */
const KEY = 'av_chatv1_device'
let cached: string | null = null

export function chatv1DeviceId(): string {
  if (cached) return cached
  try {
    const stored = localStorage.getItem(KEY)
    if (stored) return (cached = stored)
  } catch {
    /* storage disabled (private mode): fall through to a session-lifetime id */
  }
  const id = crypto.randomUUID()
  try {
    localStorage.setItem(KEY, id)
  } catch {
    /* not persistable — still stable for this page's lifetime via `cached` */
  }
  return (cached = id)
}
